import { Controller } from '@hotwired/stimulus';

/**
 * Export form - keeps the export screen's filters, preview and download in step.
 * The GET filter form refreshes the preview frame a moment after a filter changes; the period chips
 * fill the custom dates; the client radios narrow the project list; the "Everyone" box drives the
 * person boxes; and the POST download form copies the current filters right before it submits.
 * Targets: form (GET filters) | download (POST form) | from, to, custom | project, projectsClient, projectsHint | everyone, person
 * Values:  delay (Number, ms)
 * @example <div data-controller="export-form"><form data-export-form-target="form" data-action="change->export-form#refresh">…</form></div>
 */
export default class extends Controller {
  static targets = ['form', 'download', 'from', 'to', 'custom', 'project', 'projectsClient', 'projectsHint', 'everyone', 'person'];
  static values = { delay: { type: Number, default: 400 } };

  disconnect () {
    clearTimeout(this.timeout);
  }

  refresh () {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.formTarget.requestSubmit(), this.delayValue);
  }

  pickPeriod ({ params }) {
    if (params.from) this.fromTarget.value = params.from;
    if (params.to) this.toTarget.value = params.to;
  }

  pickCustom () {
    if (this.hasCustomTarget) this.customTarget.checked = true;
  }

  pickClient ({ params }) {
    const clientId = String(params.id ?? '');
    this.projectTargets.forEach((row) => {
      const matches = clientId === '' || row.dataset.clientId === clientId;
      row.hidden = !matches;
      if (!matches) row.querySelector('input').checked = false;
    });
    this.projectsClientTarget.textContent = params.name ? ` · ${params.name}` : '';
    this.projectsHintTarget.hidden = !params.name;
  }

  toggleEveryone () {
    this.personTargets.forEach((box) => { box.checked = this.everyoneTarget.checked; });
  }

  pickPerson () {
    this.everyoneTarget.checked = this.personTargets.every((box) => box.checked);
  }

  sync () {
    this.downloadTarget.querySelectorAll('input[type="hidden"]:not([name="authenticity_token"])').forEach((input) => input.remove());
    new FormData(this.formTarget).forEach((value, name) => this.downloadTarget.append(this.#hidden(name, value)));
  }

  #hidden (name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    return input;
  }
}
